import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Form, FormGroup, Input} from 'reactstrap';
import trainingPhasesActionCreators from '../../../store/training-phases/action-creators/index';
import Checkbox from '../../../../shared/forms/Checkbox';
import RejectStepSelect from './RejectStepSelect';

class RejectFormForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rejectComment: '',
      isReject: false,
      error: false,
      rejectStep: 'author'
    };
  }

  // ----------------------
  // Methods
  // ----------------------

  setReject(event) {
    this.setState({
      isReject: event.target.checked,
      isChecked: false
    })
  }

  setRejectStep(rejectStep) {
    this.setState({
      rejectStep
    })
  }

  handleSubmit(event) {
    event.preventDefault();
    if (!this.state.rejectComment) {
      return;
    }
    if (this.state.isReject) {
      this.props.rejectReport({
        reason: this.state.rejectComment,
        guid: this.props.reportGuid,
        step: this.state.rejectStep,
      })
    }
  }

  setRejectComment(comment) {
    this.setState({
      rejectComment: comment
    })
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Form noValidate onSubmit={event => this.handleSubmit(event)}>
        <FormGroup>
          <Checkbox
            label="Reject"
            name="approve"
            checked={this.state.isReject}
            onChange={(e) => this.setReject(e)}/>
        </FormGroup>

        {this.state.isReject && (
          <RejectStepSelect
            value={this.state.rejectStep}
            onChange={(rejectStep) => this.setRejectStep(rejectStep)}
          />
        )}

        <FormGroup>
          <Input
            type="textarea"
            placeholder="Reject note"
            value={this.state.rejectComment}
            onChange={(event) => this.setRejectComment(event.target.value)}
          />
        </FormGroup>

        <div className="text-danger">Reject note is required</div>


        {this.state.isReject &&
        <button className="button primary">
          Submit
        </button>
        }
      </Form>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    // TODO
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    rejectReport: (formData) => {
      dispatch(trainingPhasesActionCreators.rejectReport(formData))
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RejectFormForm);
